var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: { "close-on-click-modal": false, visible: _vm.visible },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            "status-icon": "",
            "label-width": "120px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.inputFormSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "流程分类",
                        prop: "category",
                        rules: [
                          {
                            required: true,
                            message: "流程分类不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.inputForm.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "category", $$v)
                            },
                            expression: "inputForm.category",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("act_category"),
                          function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "模型标识",
                        prop: "key",
                        rules: [
                          {
                            required: true,
                            message: "模型标识不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.key,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "key", $$v)
                          },
                          expression: "inputForm.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "模型名称",
                        prop: "name",
                        rules: [
                          {
                            required: true,
                            message: "模型标识不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "name", $$v)
                          },
                          expression: "inputForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "模块描述", prop: "description" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", placeholder: "备注" },
                        model: {
                          value: _vm.inputForm.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "description", $$v)
                          },
                          expression: "inputForm.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "noMoreClick", rawName: "v-noMoreClick" }],
              attrs: { type: "primary", icon: "el-icon-circle-check" },
              on: {
                click: function ($event) {
                  return _vm.inputFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }